module.exports = "//docs.gtimg.com/slide/img/img/cursors/edge_brush-dbf52c.cur";